// 申請内容の確認 (preview) pane + submit footer.
import { PaperPlaneTilt } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { RECEIPT_REQUIRED_MODES } from './travelModel';

export const TravelPreview = ({
  formData, transportationFee, totalAmount, submitting, isEdit, onBack, onSubmit,
}) => (
  <div className="p-6">
    <div className="bg-gradient-to-br from-zinc-50 to-white rounded-lg border-2 border-dashed border-zinc-200 p-6 sm:p-8 mb-6 shadow-inner">
      <h3 className="text-lg font-bold mb-4 border-b border-zinc-300 pb-2">申請内容の確認</h3>
      <dl className="space-y-3">
        <div className="grid grid-cols-3 gap-2">
          <dt className="font-medium text-zinc-600">氏名 ({formData.employee_names.length}名):</dt>
          <dd className="col-span-2 text-zinc-900">{formData.employee_names.join('、')}</dd>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <dt className="font-medium text-zinc-600">所属部署:</dt>
          <dd className="col-span-2 text-zinc-900">{formData.department}</dd>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <dt className="font-medium text-zinc-600">出張期間:</dt>
          <dd className="col-span-2 text-zinc-900">
            {formData.travel_start_date}
            {formData.travel_end_date && formData.travel_end_date !== formData.travel_start_date
              ? ` 〜 ${formData.travel_end_date}` : ''}
          </dd>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <dt className="font-medium text-zinc-600">用件:</dt>
          <dd className="col-span-2 text-zinc-900 whitespace-pre-wrap">{formData.purpose}</dd>
        </div>
      </dl>

      <div className="mt-6 border-t border-zinc-300 pt-4">
        <h4 className="font-bold text-zinc-900 mb-3">交通手段</h4>
        <ul className="space-y-2 text-sm">
          {formData.transport_legs.map((l) => (
            <li key={l.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-zinc-200 pb-2 last:border-0">
              <span className="px-2 py-0.5 text-xs font-medium bg-blue-50 text-blue-700 rounded">{l.mode}</span>
              <span className="text-zinc-900">{l.from} → {l.to}</span>
              <span className="ml-auto font-medium text-zinc-900">¥{Number(l.fare || 0).toLocaleString()}</span>
              {RECEIPT_REQUIRED_MODES.has(l.mode) && (
                <span className="w-full text-xs text-zinc-500">領収書: {(l.receipts || []).length}件添付</span>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-6 border-t border-zinc-300 pt-4">
        <h4 className="font-bold text-zinc-900 mb-3">精算明細</h4>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-zinc-600">交通費:</span><span>¥{transportationFee.toLocaleString()}</span></div>
          <div className="flex justify-between"><span className="text-zinc-600">宿泊料:</span><span>¥{Number(formData.accommodation_fee || 0).toLocaleString()}</span></div>
          <div className="flex justify-between"><span className="text-zinc-600">日当:</span><span>¥{Number(formData.daily_allowance || 0).toLocaleString()}</span></div>
          <div className="flex justify-between"><span className="text-zinc-600">食事代:</span><span>¥{Number(formData.meal_fee || 0).toLocaleString()}</span></div>
          <div className="flex justify-between"><span className="text-zinc-600">その他:</span><span>¥{Number(formData.other_fees || 0).toLocaleString()}</span></div>
          <div className="flex justify-between border-t-2 border-zinc-900 pt-2 mt-2">
            <span className="font-bold">合計金額:</span>
            <span className="font-bold text-teal-700 text-lg">¥{totalAmount.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
    <div className="flex justify-end space-x-3">
      <Button variant="outline" onClick={onBack} className="border-zinc-300">戻る</Button>
      <Button onClick={onSubmit} disabled={submitting} data-testid="form-submit-btn" className="bg-teal-700 hover:bg-teal-800 shadow-sm hover:shadow-md transition-all">
        <PaperPlaneTilt size={18} className="mr-2" />
        {submitting ? (isEdit ? '更新中…' : '登録中…') : (isEdit ? '更新する' : '登録する')}
      </Button>
    </div>
  </div>
);
